import { render } from "./UiLink.vue?vue&type=template&id=fe93399c&scoped=true"
import script from "./UiLink.vue?vue&type=script&lang=js"
export * from "./UiLink.vue?vue&type=script&lang=js"

import "./UiLink.vue?vue&type=style&index=0&id=fe93399c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\merk\\Documents\\_kwork\\virginia79\\lk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe93399c"]])

export default __exports__